import { Injectable, signal } from '@angular/core';
import { Tab } from '../../../state/app.state';

/**
 * Holds in-flight PDF-report jobs at app-root scope so generation survives navigation:
 * the off-screen render hosts live in AppComponent (always mounted), not in the route-scoped
 * results page. Each frozen tab snapshot drives its own self-capturing host.
 */
@Injectable({ providedIn: 'root' })
export class ReportJobsService {
  readonly companyJobs = signal<Tab[]>([]);
  readonly themeJobs = signal<Tab[]>([]);

  addCompanyJob(tab: Tab): void {
    if (this.isCompanyGenerating(tab.tabId)) return;
    this.companyJobs.update(jobs => [...jobs, tab]);
  }

  addThemeJob(tab: Tab): void {
    if (this.isThemeGenerating(tab.tabId)) return;
    this.themeJobs.update(jobs => [...jobs, tab]);
  }

  removeCompanyJob(tabId: string): void {
    this.companyJobs.update(jobs => jobs.filter(t => t.tabId !== tabId));
  }

  removeThemeJob(tabId: string): void {
    this.themeJobs.update(jobs => jobs.filter(t => t.tabId !== tabId));
  }

  isCompanyGenerating(tabId?: string | null): boolean {
    return !!tabId && this.companyJobs().some(t => t.tabId === tabId);
  }

  isThemeGenerating(tabId?: string | null): boolean {
    return !!tabId && this.themeJobs().some(t => t.tabId === tabId);
  }
}
